module.exports = __webpack_public_path__ + "static/img/start-prediction.ac314b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/start-prediction.png
// module id = uPBK
// module chunks = 1